export default {
  tabs: {
    fiinTradeRankings: 'FiinTrade Xếp Hạng',
    allScore: 'Đánh Giá',
  },
  tabChildrens: {
    all: 'Tất cả',
    hose: 'hose',
    hnx: 'hnx',
    rankingIndicators: 'Chỉ tiêu',
    ranking: 'Thứ hạng',
  },
  popup: {
    warning: {
      title: 'Không tìm thấy cổ phiếu',
      content:
        'Cổ phiếu bạn tìm kiếm không được xếp hạng trong nhóm này. Hãy thử lại',
    },
    ranking: {
      fiinTradeRank: 'FiinTrade Xếp Hạng',
      transportation: 'Vận Tải', //Đây là tên ngành, phụ thuộc vào ticker
      value: 'Gía trị',
      growth: 'Tăng trưởng',
      momentum: 'Động lực',
      vgm: 'VGM',
    },
  },
  footerTextScore:
    'Để thêm thông tin về cách tối ưu hóa Đánh Giá Đầu Tư của FiinTrade, ',
  footerTextRanking:
    'Để thêm thông tin về cách tối ưu hóa Đánh Giá Đầu Tư của FiinTrade, ',
  footerClickHere: 'click tại đây',
  titleTableAllScore: 'Đánh Giá Đầu Tư của FiinTrade',
  titleTableRanking: 'Hệ Thống Xếp Hạng Cổ Phiếu của FiinTrade',
  fiinTradeRankingsHeader: {
    rtd11: 'Vốn hóa (Tỷ)',
    rankValue: 'Thứ Hạng',
    ticker: 'Mã',
    icbName: 'Ngành',
    rankingHistory: 'Lịch sử Thứ hạng',
    size: 'Quy Mô',
    profit: 'Lợi Nhuận',
    cashflow: 'Dòng tiền',
    valuation: 'Định Giá',
    trading: 'Giao dịch',
    analysisCover: 'Tỷ lệ Báo cáo Phân tích',
    allIndustries: 'Nhóm',
    ranking: 'Xếp Hạng',
    value: 'Giá trị',
    growth: 'Tăng trưởng',
    momentum: 'Động lực',
    vgm: 'VGM',
  },
  fiinTradeAllScoreHeader: {
    ticker: 'Mã',
    ranking: 'Xếp hạng',
    icbName: 'Tất cả các ngành',
    rtd11: 'Vốn hóa',
    value: 'Giá trị',
    growth: 'Tăng trưởng',
    momentum: 'Động lực',
    vgm: 'VGM',
  },
};
